//----- Component --------------------------------------------------------/
// Developer : Daiana Curcio
// Creation Date : 31/03/2025
// Version : 1
// Description : pantalla de servicios para tanques y agregar tareas
//------Changes --------------------------------------------------------//
// Change Date :
// Change by :
// Change description:
// Change Date :
// Change by :
// Change description:
//========================================================================/
import React, { useEffect, useState, useMemo } from "react";
import { UrlApi } from "../../services/apirest";
import {
  Container,
  Typography,
  Tooltip,
  IconButton,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  Grid,
  DialogTitle,
  TextField,
} from "@mui/material";
import MaterialReactTable, {
  MRT_FullScreenToggleButton,
} from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es"; //Tabla en español
import AddBoxTwoToneIcon from "@mui/icons-material/AddBoxTwoTone";
import BlockIcon from "@mui/icons-material/Block";
import EditIcon from "@mui/icons-material/Edit";
import Notify from "../Notify";
import { createTheme, ThemeProvider, useTheme } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ContentPasteIcon from "@mui/icons-material/ContentPaste";
import ContentPasteOffIcon from "@mui/icons-material/ContentPasteOff";
import { logEventos } from "../../services/services";
import Agregar_servicio from "./Agregar_servicio";
import BuildIcon from "@mui/icons-material/Build";
import moment from "moment";
import EditarServicio from "./EditarServicio";
import TareasServicio from "./TareasServicio";


function ServiciosPrincipal(props) {
  const [datosTanque, setDatosTanque] = useState(props.datos); // viene de tanque rehab
  const [servicio, setServicio] = useState(props.servicio); //tabla
  const [datosServicios, setDatosServicios] = useState({}); //tabla
  const [alta, setAlta] = useState(false); //Estado q mostrará o no la pantalla de alta
  const [altaITEM, setAltaITEM] = useState(false); //Estado q mostrará o no la pantalla de alta
  const [tabla, setTabla] = useState(true);
  const [editar, setEditar] = useState(false); //Estado q mostrará o no el form de edicion de choferes
  const [confirmar, setConfirmar] = useState(false);
  const globalTheme = useTheme();
  const [notificacion, setNotificacion] = useState(false); //define si se muestra o no una notificación (snackbar)
  const [openSnack, setOpenSnack] = React.useState(false); //abre y cierra snack
  const [colormensaje, setColorMensaje] = useState("");
  const [severityAlerta, setSeverityAlerta] = useState(""); //define severidad de la alerta (success error o warning)
  const [severitySnack, setSeveritySnack] = useState(""); //define severidad del snackbar (notificación)
  const [mensaje, setMensaje] = useState(""); //mensaje q mostrará la notif
  const [mensajeAlerta, setMensajeAlerta] = useState(""); //mensaje que contendrá el componente "alerta"
  const [error, setError] = useState(null); //guardará el error que lance la api (si existe)
  const [hiddenmuestrainactivo, setHiddenmuestrainactivo] = useState(false);
  const [hiddenmuestraactivos, setHiddenmuestraactivos] = useState(true);
  const [obt, setObt] = useState(0);
  const [fechas, setFechas] = useState(false);
  const [disabledGuardar, setDisabledGuardar] = useState(false);

  //  //    //acceso al menu
  useEffect(() => {
    logEventos(
      "Acceso al menú servicios",
      "Tanques Moviles",
      "Agregar,editar,activar o desactivar un servicio y agregar tareas",
      localStorage.getItem("user")
    );
  }, []);
  //*************************************************************************************************************************************/
  const obtenerServicios = () => {
    setHiddenmuestraactivos(true);
    setHiddenmuestrainactivo(false);
    fetch(UrlApi + "/tanque_servicio/activos/" + datosTanque.id_tanque)
      .then((data) => data.json())
      .then((data) => setServicio(data));
  };
  const obtenerinactivos = () => {
    setHiddenmuestrainactivo(true);
    setHiddenmuestraactivos(false);
    fetch(UrlApi + "/tanque_servicio/inactivos/" + datosTanque.id_tanque)
      .then((data) => data.json())
      .then((data) => setServicio(data));
  };
  //ejecuta la funcion de obtener
  useEffect(() => {
    obtenerServicios();
  }, [tabla, obt, confirmar]);

  //*************************************************************************************************************************************/
  //funcion para almacenar
  const almacenar = (e) => {
    setDatosTanque({
      ...datosTanque,
      [e.target.name]: e.target.value === "" ? null : e.target.value,
    });
  };
  const style = {
    backgroundColor: "#ffffff",
    width: "100%",
  };

  const handleVolver = () => {
    setConfirmar(false);
    setFechas(false);
    setTabla(true);
  };

  const handleClickNuevo = () => {
    setAlta(true);
    setTabla(false);
  };

  const abrirModalConfirmar = (datosDeLaLinea) => {
    setConfirmar(true);
    setDatosServicios(datosDeLaLinea);
  };

  const abrirModalConfirmarFinServicio = (datosDeLaLinea) => {
    // setConfirmar(true);
    setFechas(true);
    setDatosServicios(datosDeLaLinea);
  };

  useEffect(() => {
    if (props.datos) {
      setDatosTanque(props.datos);
    }
  }, [props.datos]);

  const handleClose = () => {
    setServicio(!servicio);
    if (props.onClose) {
      props.onClose();
    }
  };

  const mostrareditar = (datosDeLaLinea) => {
    setEditar(true);
    setTabla(false);
    setDatosServicios(datosDeLaLinea);
    // console.log("datos linea", datosDeLaLinea ? datosDeLaLinea : "NO");
  };

  //*************************************************************************************************************************************/
  // columnas tabla
  const columns = useMemo(
    () => [
      {
        header: "Desde",
        accessorFn: (desde) =>
          moment(desde.servicio_desde).format("DD-MM-YYYY"),
        size: 100,
      },
      {
        header: "Hasta",
        accessorFn: (hasta) =>
          moment(hasta.servicio_hasta).format("DD-MM-YYYY"),
        size: 100,
      },
      {
        header: "Motivo",
        accessorKey: "motivo_servicio",
        size: 200,
      },
      {
        header: "Detalle",
        accessorKey: "detalle_servicio",
        size: 200,
      },
      {
        header: "Lugar",
        accessorKey: "lugar_servicio",
        size: 200,
      },
    ],
    []
  );
  const tableTheme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: globalTheme.palette.mode, //let's use the same dark/light mode as the global theme
          primary: globalTheme.palette.primary, //primary color for the table
          info: {
            main: "rgb(255,122,0)", //add in a custom color for the toolbar alert background stuff
          },
          background: {
            default:
              globalTheme.palette.mode === "light"
                ? "rgb(234, 239, 241)" //background in light mode
                : "#000", //pure black table in dark mode for fun
          },
        },
        typography: {
          button: {
            textTransform: "none", //customize typography styles for all buttons in table by default
            fontSize: "1rem",
          },
        },
        components: {
          MuiTooltip: {
            styleOverrides: {
              tooltip: {
                fontSize: "0.8rem", //override to make tooltip font size larger
              },
            },
          },
        },
      }),
    [globalTheme]
  );
  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
    variant: "outlined",
    color: "success",
    size: "small",
  };
  const initialState = {
    //para inicializar la tabla, y la cantidad de paginas q se ven ej 5
    density: "compact",
    showGlobalFilter: true,
    pagination: { pageIndex: 0, pageSize: 10 },
  };
  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };
  //*************************************************************************************************************************************/
  const marcarInactivo = async () => {
    logEventos(
      "Marcar como inactivo un servicio",
      "Tanques Moviles",
      "Se guardo el servicio inactivo",
      localStorage.getItem("user")
    );
    const response = await fetch(
      UrlApi + "/tanque_servicio/" + datosServicios.id_servicio,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(
          datosServicios.estado_servicio === 0
            ? { estado_servicio: 1 }
            : { estado_servicio: 0 }
        ),
      }
    );
    if (response.ok === false) {
      const error = response && response.json();
      setError(error);
      alert("Inconvenientes con la API. No se pudo guardar. ");
    } else {
      try {
        const json = await response.json();
        if (json.message) {
          setNotificacion(true);
          setOpenSnack(true);
          setMensaje(
            json.message === "OK" ? "Guardado" : "Guardado. Actualizar RTA Api."
          );
          obtenerServicios();
        } else if (json.sqlMessage) {
          json && setError(json);
          alert("SQL erróneo (" + json.code + " Errno: " + json.errno + " )");
        } else {
          alert("ERROR DESCONOCIDO.");
        }
      } catch (error) {
        if (error.toString().includes("is not valid JSON")) {
          setNotificacion(true);
          setOpenSnack(true);
          setMensaje("Guardado");
          obtenerServicios();
        } else {
          alert("Error: " + error);
        }
      }
    }
    handleVolver();
    obtenerServicios();
  };

  //------------- CALCULO DE FECHAS PROXIMAS EN EL FINALIZAR SERVICIO--------------------//
  // ULTIMA REVISION QUINQUENAL suma 5 AÑOS
  const fechaUltima = moment(datosTanque.fecha_ultima);
  const fechaProxUltima = fechaUltima.add(5, "years").format("YYYY-MM-DD");
  // VALVULA DE SEGURIDAD suma 2 AÑOS
  const fechaRevValSeg = moment(datosTanque.fecha_rev_val_seg);
  const fechaProxRevValSeg = fechaRevValSeg
    .add(2, "years")
    .format("YYYY-MM-DD");
  // VALVULA DE EXCESO suma 1 AÑO
  const fechaRevValExc = moment(datosTanque.fecha_rev_val_exc);
  const fechaproxRevValExc = fechaRevValExc
    .add(1, "years")
    .format("YYYY-MM-DD");
  // REVISION DE MANGUERA suma 6 MESES
  const fechaRevMan = moment(datosTanque.fecha_rev_man);
  const fechaProxRevMan = fechaRevMan.add(6, "months").format("YYYY-MM-DD");

  // REVISION DE VTV
  const fechaVTV = moment(datosTanque.fecha_vtv);
  let fechaProxVTV = null;
  if (datosTanque.tipo_ven_vtv == 331) {
    //anual
    fechaProxVTV = fechaVTV.add(1, "years").format("YYYY-MM-DD");
  } else if (datosTanque.tipo_ven_vtv == 332) {
    //semestral
    fechaProxVTV = fechaVTV.add(6, "months").format("YYYY-MM-DD");
  } else if (datosTanque.tipo_ven_vtv == 333) {
    // c/4 meses
    fechaProxVTV = fechaVTV.add(4, "months").format("YYYY-MM-DD");
  } else {
    fechaProxVTV = null;
  }
  // MATAFUEGOS 1 AÑO
  const fechaMatafuego = moment(datosTanque.fecha_oblea_matafuegos);
  const fechaproxMatafuego = fechaMatafuego
    .add(1, "years")
    .format("YYYY-MM-DD");

  // REVISION DE SEGURO
  const fechaSeguro = moment(datosTanque.fecha_seguro);
  let fechaProxSeguro = null;
  if (datosTanque.tipo_ven_seguro == 334) {
    //mensual
    fechaProxSeguro = fechaSeguro.add(1, "months").format("YYYY-MM-DD");
  } else if (datosTanque.tipo_ven_seguro == 335) {
    //semestral
    fechaProxSeguro = fechaSeguro.add(6, "months").format("YYYY-MM-DD");
  } else if (datosTanque.tipo_ven_seguro == 336) {
    //anual
    fechaProxSeguro = fechaSeguro.add(1, "years").format("YYYY-MM-DD");
  } else {
    fechaProxSeguro = null;
  }

  //Funcion para guardar
  const guardarEditar = async (e) => {
    logEventos(
      "Guardar editar fechas",
      "Tanques Moviles",
      "Se guardo la edición",
      localStorage.getItem("user")
    );
    // setDisabledGuardar(true);
    e.preventDefault();
    const response = await fetch(
      UrlApi + "/tanque_rehabilitacion/" + datosTanque.id_tanque,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          fecha_ultima: datosTanque.fecha_ultima,
          fecha_rev_val_seg: datosTanque.fecha_rev_val_seg,
          fecha_rev_val_exc: datosTanque.fecha_rev_val_exc,
          fecha_rev_man: datosTanque.fecha_rev_man,
          prox_ultima: fechaProxUltima,
          prox_rev_val_seg: fechaProxRevValSeg,
          prox_rev_val_exc: fechaproxRevValExc,
          prox_rev_man: fechaProxRevMan,
          fecha_vtv: datosTanque.fecha_vtv,
          prox_vtv: fechaProxVTV,
          fecha_oblea_matafuegos: datosTanque.fecha_oblea_matafuegos,
          prox_oblea_matafuegos: fechaproxMatafuego,
          fecha_seguro: datosTanque.fecha_seguro,
          prox_seguro: fechaProxSeguro,
          usuario: localStorage.getItem("user"),
        }),
      }
    );
    if (response.ok === false) {
      console.log("ERROR EN API");
      const error = response && response.json();
      setError(error);
      setSeverityAlerta("error");
      setMensajeAlerta("Inconvenientes con la API. No se pudo guardar. ");
    } else {
      console.log("Conexión con api OK");
      try {
        //Parseo respuesta de la api a json()
        const json = await response.json();
        //si api me devuelve lo q le puse en message
        if (json.message) {
          //Si ese mensaje es "OK"
          if (json.message === "OK") {
            console.log("Guardado Satisfactoriamente");
            await marcarInactivo();
            setNotificacion(true);
            setOpenSnack(true);
            setColorMensaje("#D4EFDF");
            setMensaje("Guardado");
            setSeveritySnack("success");
          } else {
            console.log("res en api incorrecto. Revisar que sea 'OK'");
            setNotificacion(true);
            setOpenSnack(true);
            setColorMensaje("#D4EFDF");
            setSeveritySnack("error");
            setMensaje("Registro Guardado. REVISAR RESPUESTA DE API (E_S)");
          }
        } else if (json.sqlMessage) {
          json && setError(json);
          console.log(json);
          setMensajeAlerta(
            "SQL erróneo (" + json.code + " Errno: " + json.errno + " )"
          );
        } else {
          setMensajeAlerta("ERROR DESCONOCIDO.");
        }
      } catch (error) {
        if (error.toString().includes("is not valid JSON")) {
          console.log(
            "Guardado. Advertencia: Actualizar respuesta de api. JSON invalido."
          );
          setNotificacion(true);
          setOpenSnack(true);
          setColorMensaje("#D4EFDF");
          setMensaje("Guardado");
          setSeveritySnack("success");
        } else {
          setMensajeAlerta("ERROR DESCONOCIDO.");
        }
      }
    }
    handleVolver();
  };

 // console.log("DATOS TANQUE SEEVICIO PRINC", datosTanque);

  return (
    <div>
      <Container maxWidth={false} disableGutters sx={{ mt: 1, mb: 2 }}>
        {servicio && tabla ? (
          <Box mt={2} boxShadow={3}>
            <ThemeProvider theme={tableTheme}>
              <MaterialReactTable
                enableColumnResizing
                columns={columns}
                data={servicio}
                initialState={initialState}
                positionActionsColumn="last"
                enableExpandAll={false}
                enableToolbarInternalActions={true}
                muiTableHeadCellProps={tableHeadCellProps}
                muiTableBodyCellProps={({ row }) => ({
                  align: "left",
                  sx: {
                    backgroundColor:
                      row.original.estado_servicio === 0
                        ? "#efc3c3"
                        : "#b3e6b3",
                    color: "black",
                    borderColor: "black",
                  },
                })}
                enableColumnActions={false}
                muiSearchTextFieldProps={muiSearchTextFieldProps}
                enableDensityToggle={false}
                renderTopToolbarCustomActions={() => (
                  <>
                    <Button
                      variant="contained"
                      onClick={handleClose}
                      style={{ backgroundColor: "#d32f2f", color: "#ffffff" }}
                      size="small"
                    >
                      Volver
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      startIcon={<AddBoxTwoToneIcon />}
                      onClick={handleClickNuevo}
                      size="small"
                    >
                      Nuevo Servicio
                    </Button>

                    <Typography variant="poster" fontSize={26}>
                      <BuildIcon sx={{ size: 20 }} />
                      Servicios del tanque: {datosTanque.patente}
                    </Typography>
                  </>
                )}
                layoutMode="grid"
                localization={MRT_Localization_ES}
                enableColumnDragging={false} //No permite que se arrastren las columnas.
                enableEditing
                // LLAMA A LA TABLA DE ITEMS
                renderDetailPanel={({ row }) => (
                  <div style={{ marginTop: "-50px" }}>
                    <Box
                      sx={{
                        width: "160%",
                      }}
                    >
                      <TareasServicio row={row} datos={datosTanque} />
                    </Box>
                  </div>
                )}
                renderToolbarInternalActions={(
                  { table } // boton para nuevo , al lado del buscar
                ) => (
                  <>
                    {!hiddenmuestraactivos ? (
                      <Tooltip title="Ver servicios abiertos">
                        <IconButton
                          color="success"
                          onClick={() => {
                            obtenerServicios();
                          }}
                        >
                          <ContentPasteIcon />
                        </IconButton>
                      </Tooltip>
                    ) : null}
                    {!hiddenmuestrainactivo ? (
                      <Tooltip title="Ver servicios terminados">
                        <IconButton
                          color="error"
                          onClick={() => {
                            obtenerinactivos();
                          }}
                        >
                          <ContentPasteOffIcon />
                        </IconButton>
                      </Tooltip>
                    ) : null}
                    <MRT_FullScreenToggleButton table={table} />
                  </>
                )}
                renderRowActions={(
                  { row } //las acciones del costado editar y ver
                ) => (
                  <div>
                    <Tooltip arrow placement="left" title="Editar servicio">
                      <IconButton
                        onClick={() => mostrareditar(row.original)}
                        color="primary"
                      >
                        <EditIcon />
                      </IconButton>
                    </Tooltip>
                    {row.original.estado_servicio === 0 ? (
                      <Tooltip title="Marcar como abierto">
                        <IconButton
                          color="success"
                          onClick={() => abrirModalConfirmar(row.original)}
                        >
                          <CheckCircleOutlineIcon />
                        </IconButton>
                      </Tooltip>
                    ) : (
                      <Tooltip title="Marcar como terminado">
                        <IconButton
                          onClick={() =>
                            abrirModalConfirmarFinServicio(row.original)
                          }
                          color="error"
                        >
                          <BlockIcon />
                        </IconButton>
                      </Tooltip>
                    )}
                  </div>
                )}
              />
            </ThemeProvider>
            <br />
            <br />
          </Box>
        ) : null}

        {confirmar ? (
          <div>
            <Dialog open={confirmar} onClose={handleVolver}>
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  marcarInactivo();
                }}
              >
                <Box backgroundColor={"#1F618D"}>
                  <DialogTitle>
                    {datosServicios.estado_servicio === 0 ? (
                      <Typography variant="h6" align="center" color="#ffffff">
                        Abierto {datosServicios.motivo_servicio}
                      </Typography>
                    ) : (
                      <Typography variant="h6" align="center" color="#ffffff">
                        Terminado {datosServicios.motivo_servicio}
                      </Typography>
                    )}
                  </DialogTitle>
                </Box>
                <DialogContent>
                  <DialogContentText textAlign={"center"}>
                    {datosServicios.estado_servicio === 0 ? (
                      <> ¿Desea abrir el servicio ? </>
                    ) : (
                      <> ¿Desea terminar el servicio ? </>
                    )}
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItemns="center"
                  >
                    <Button
                      variant="contained"
                      onClick={handleVolver}
                      style={{ backgroundColor: "#d32f2f", color: "#ffffff" }}
                    >
                      Cancelar
                    </Button>
                    <Button
                      style={{ backgroundColor: "#2e7d32", color: "#ffffff" }}
                      type="submit"
                      variant="contained"
                      color="primary"
                    >
                      Confirmar
                    </Button>
                  </Grid>
                </DialogActions>
              </form>
            </Dialog>
          </div>
        ) : null}
        {notificacion ? (
          <Notify
            mensaje={mensaje}
            open={openSnack}
            color={"#D4EFDF"}
            severity={"success"}
            handleClose={handleVolver}
          />
        ) : null}
        {alta ? (
          <Agregar_servicio
            datos={datosTanque}
            alta={setAlta}
            tabla={setTabla}
          ></Agregar_servicio>
        ) : null}
        {editar ? (
          <EditarServicio
            editar={setEditar}
            tabla={setTabla}
            datos={datosServicios}
            actualizar={setObt}
          ></EditarServicio>
        ) : null}
        {fechas ? (
          <div>
            <Dialog open={fechas} onClose={handleVolver}>
              <form onSubmit={guardarEditar}>
                {/* <Box backgroundColor={"#1F618D"}>
                  <DialogTitle sx={{ color: "white" }}>Cambio de fecha al servicio : {datosServicios.motivo_servicio} con {datosServicios.detalle_servicio}</DialogTitle>
                </Box> */}
                <Box backgroundColor={"#1F618D"}>
                  <DialogTitle sx={{ color: "white" }}>
                    <Typography variant="h5" color="white" align="center">
                      Finalizar servicio
                    </Typography>
                  </DialogTitle>
                </Box>
                <Box
                  variant="h6"
                  color="black"
                  sx={{
                    whiteSpace: "pre-line",
                    backgroundColor: "#f0f0f0",
                    border: "1px solid",
                    borderColor: "#1976D2",
                    padding: 2,
                    borderRadius: 2,
                    boxShadow: 1,
                    lineHeight: 1.6,
                    mt: 2,
                    mr: 3,
                    ml: 3,
                  }}
                >
                  <Typography>
                    Patente del tanque: {datosTanque.patente}
                    {"\n"}
                    Motivo: {datosServicios.motivo_servicio}
                    {"\n"}
                    Detalle: {datosServicios.detalle_servicio}
                  </Typography>
                </Box>
                <Box
                  backgroundColor={"#f0f0f0"}
                  sx={{
                    whiteSpace: "pre-line",
                    backgroundColor: "#f0f0f0",
                    border: "1px solid",
                    borderColor: "#1976D2",
                    padding: 2,
                    borderRadius: 2,
                    boxShadow: 1,
                    lineHeight: 1.6,
                    mt: 2,
                    mr: 3,
                    ml: 3,
                  }}
                >
                  <DialogContent>
                    <DialogContentText textAlign={"center"}>
                      <Container maxWidth="xl">
                        <Grid
                          container
                          spacing={2}
                          // justifyContent="center"
                          alignItems="center"
                        >
                          <Grid item xs={6}>
                            <TextField
                              style={style}
                              label="Revisión Quinquenal"
                              name="fecha_ultima"
                              size="small"
                              type="date"
                              focused
                              required
                              fullWidth
                              value={moment(datosTanque.fecha_ultima).format(
                                "YYYY-MM-DD"
                              )}
                              onChange={almacenar}
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              style={style}
                              label="Revisión valvulas seguridad"
                              name="fecha_rev_val_seg"
                              size="small"
                              type="date"
                              focused
                              required
                              fullWidth
                              value={moment(
                                datosTanque.fecha_rev_val_seg
                              ).format("YYYY-MM-DD")}
                              onChange={almacenar}
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              style={style}
                              label="Revisión válvulas exceso"
                              name="fecha_rev_val_exc"
                              size="small"
                              type="date"
                              focused
                              required
                              fullWidth
                              value={moment(
                                datosTanque.fecha_rev_val_exc
                              ).format("YYYY-MM-DD")}
                              onChange={almacenar}
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              style={style}
                              label="Revisión mangueras"
                              name="fecha_rev_man"
                              size="small"
                              type="date"
                              focused
                              required
                              fullWidth
                              value={moment(datosTanque.fecha_rev_man).format(
                                "YYYY-MM-DD"
                              )}
                              onChange={almacenar}
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              style={style}
                              label="Vencimiento VTV"
                              name="fecha_vtv"
                              size="small"
                              type="date"
                              focused
                              required
                              fullWidth
                              value={moment(datosTanque.fecha_vtv).format(
                                "YYYY-MM-DD"
                              )}
                              onChange={almacenar}
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              style={style}
                              label="Oblea de matafuegos"
                              name="fecha_oblea_matafuegos"
                              size="small"
                              type="date"
                              focused
                              required
                              fullWidth
                              value={moment(
                                datosTanque.fecha_oblea_matafuegos
                              ).format("YYYY-MM-DD")}
                              onChange={almacenar}
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              style={style}
                              label="Vencimiento del seguro"
                              name="fecha_seguro"
                              size="small"
                              type="date"
                              focused
                              required
                              fullWidth
                              value={moment(datosTanque.fecha_seguro).format(
                                "YYYY-MM-DD"
                              )}
                              onChange={almacenar}
                            />
                          </Grid>
                        </Grid>
                      </Container>
                    </DialogContentText>
                  </DialogContent>
                </Box>
                <DialogActions>
                  <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItemns="center"
                  >
                    <Button
                      variant="contained"
                      onClick={handleVolver}
                      style={{ backgroundColor: "#d32f2f", color: "#ffffff" }}
                    >
                      Cancelar
                    </Button>
                    <Button
                      style={{ backgroundColor: "#2e7d32", color: "#ffffff" }}
                      type="submit"
                      variant="contained"
                      color="primary"
                    >
                      Confirmar
                    </Button>
                  </Grid>
                </DialogActions>
              </form>
            </Dialog>
          </div>
        ) : null}
      </Container>
    </div>
  );
}

export default ServiciosPrincipal;
